<template>
  <ParagraphBody>
    <Checkbox
      isMarkdown
      :label="addAndroidDevice.byodBody.checkBoxText"
      name="allowUserEnrollMobileDevice"
      :value="allowUserEnrollMobileDevice"
      @input="handleUserEnrollMobileDevice"
    />
    <div v-if="allowUserEnrollMobileDevice">
      <div :class="$style.selectfield">
        {{ addAndroidDevice.selectLabel }}
      </div>
      <Select
        v-model="selectedDeviceGroup"
        :class="$style.selectItem"
        :options="deviceGroupOptions"
        :placeholder="addAndroidDevice.selectText"
        :value="deviceGroupValue"
        @input="deviceGroup => handleDeviceGroupChange(deviceGroup)"
      />
    </div>
  </ParagraphBody>
</template>

<script>
import { AndroidEmmConsts, ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import {
  Checkbox,
  ParagraphBody,
  Select,
} from '@jumpcloud/ui-components';
import { mapActions, mapGetters, mapState } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';

const GroupCollection = StoreModuleMap[ItemTypeConsts.group];
const googleModule = StoreModuleMap[ItemTypeConsts.mdmGoogle];

export default {
  name: 'GoogleEmmDynamicSelectModal',

  components: {
    Checkbox,
    ParagraphBody,
    Select,
  },

  data: () => ({
    addAndroidDevice: AndroidEmmConsts.creatAndroidDeviceText,
    allowUserEnrollMobileDevice: false,
    deviceGroupValue: '',
    selectedDeviceGroup: '',
  }),

  computed: {
    ...mapGetters(GroupCollection, {
      items: 'getCollection',
    }),
    ...mapState(googleModule, [
      'googleEmmEnterpriseObj',
    ]),

    deviceGroupOptions() {
      const options = [{ name: 'None', value: '' }];
      if (this.items) {
        const groupOptions = this.items.map(group => ({ name: group.name, value: group.id }));
        options.push(...groupOptions);
      }
      return options;
    },
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    ...mapActions(GroupCollection, [
      'fetchEntireCollection',
      'setFilter',
    ]),
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
      'triggerSuccessNotification',
    ]),
    ...mapActions(googleModule, [
      'updateEnterprise',
    ]),

    async handleDeviceGroupChange(deviceGroup) {
      this.deviceGroupValue = deviceGroup;
      try {
        const data = {
          allowDeviceEnrollment: this.allowUserEnrollMobileDevice,
          deviceGroupId: this.deviceGroupValue,
          organizationObjectId: this.googleEmmEnterpriseObj.organizationObjectId,
        };
        const { enterpriseObjectId } = this.googleEmmEnterpriseObj;
        await this.updateEnterprise({ enterpriseObjectId, data });
        if (deviceGroup) {
          this.triggerSuccessNotification({
            title: 'Success',
            message: 'Successfully set default device group.',
          });
        } else {
          this.triggerSuccessNotification({
            title: 'Success',
            message: 'End User enrollment successfully disabled.',
          });
        }
      } catch {
        this.triggerErrorNotification({
          title: 'Error',
          message: 'Unable to set default device group.',
        });
      }
    },

    handleEnrollmentInstructionClose() {
      this.isShowEnrollmentInstructions = false;
    },

    async handleMounted() {
      try {
        this.allowUserEnrollMobileDevice = this.googleEmmEnterpriseObj.allowDeviceEnrollment;
        this.selectedDeviceGroup = this.googleEmmEnterpriseObj.deviceGroupId;
        const filter = {
          name: 'type',
          operator: 'eq',
          value: ItemTypeConsts.systemGroup,
        };
        this.setFilter({ filter });
        await this.fetchEntireCollection();
      } catch {
        this.triggerErrorNotification({
          title: 'Error',
          message: 'Unable to fetch device group.',
        });
      }
    },

    handleUserEnrollMobileDevice(value) {
      this.allowUserEnrollMobileDevice = value;
      if (!this.allowUserEnrollMobileDevice) {
        this.handleDeviceGroupChange('');
      }
    },
  },
};
</script>

<style module>
.selectfield {
  margin-bottom: var(--jc-spacer-small);
  margin-top: var(--jc-spacer-medium);
}

.selectItem {
  width: 28.125rem;
}
</style>
